import { z } from 'zod';

import { email, phone, picked, required, tooLong } from '@mds/shared/lib/validation';

/** The CV types the drop zone takes, by extension. */
export const CV_EXTENSIONS = ['pdf', 'doc', 'docx'] as const;
/** The largest CV the drop zone takes: 10 MB. */
export const CV_MAX_BYTES = 10 * 1024 * 1024;

/**
 * The careers application, as `POST /api/applications` takes it. The role is
 * one of the API's `WORK_FIELDS`, since the dropdown offers nothing else.
 *
 * The CV's type and size are checked by the drop zone as a file is picked, so
 * a wrong one never reaches the form; here it only has to be there.
 */
export const careersSchema = z.object({
  fullName: required('Full name').max(160, tooLong(160)),
  email,
  phone,
  field: picked('Choose a role.'),
  cv: z
    .custom<File | null>((value) => value instanceof File, 'Attach your CV.')
    .transform((value) => value as File),
});

export type CareersForm = z.input<typeof careersSchema>;
export type CareersApplication = z.output<typeof careersSchema>;
